import React, { useState, useMemo } from "react";
import "./hostScreen.css";
import { useDispatch, useSelector } from "react-redux";
import HostImageGrid from "./HostImageGrid";
import VegIconSvg from "../../assets/ReactSvg/VegSvgIcon";
import NonVegIconSvg from "../../assets/ReactSvg/NonVegSvgIcon";
import PremiumExpIconSvg from "../../assets/ReactSvg/PremiumExpIconSvg";
import GourmetIconSvg from "../../assets/ReactSvg/GourmetIconSvg";
import PlayIconSvg from "../../assets/ReactSvg/PlayIconSvg";
import { S3_MENU_THUMBNAIL_FOLDER } from "../../store/constants";
import LazyVideo from "./LazyVideo";
import "video-react/dist/video-react.css";
import { menuActions } from "../../store/menuSlice";
import { bottomBarActions } from "../../store/bottomBarSlice";
import { chefActions } from "../../store/chefSlice";
import FoundersCuratedComponent from "./FoundersCuratedComponent";

const STATIC_EXPERIENCE_TYPES = [
  { label: "Premium", icon: PremiumExpIconSvg },
  { label: "Gourmet", icon: GourmetIconSvg },
];

const getMediaUrl = (media) =>
  typeof media === "string"
    ? media
    : media?.url || media?.link || media?.src || "";

const isVideoUrl = (url) => /\.(mp4|mov|webm)(\?.*)?$/i.test(url);

const getAllPhotos = (data) =>
  data.flatMap((item) => [
    ...(item.photos || []),
    ...(item.mediaUrl ? [item.mediaUrl] : []),
    ...(item.media && !item.mediaUrl ? [item.media] : []),
  ]);

const HostDetailsComponent = ({
  chefLabel1,
  chefName,
  hostDetails,
  experienceType,
  distance,
  kitchenInfo,
  expertStoryVideos = [],
  onChefClick,
  onViewAllClick,
  hostExperience = [],
  chefId,
  showFounders= false
}) => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state.chef.categories);
  const chefList = useSelector((state) => state.chef.chefList);
  const [showFullAboutText, setShowFullAboutText] = useState(false);
  const { locationName, address, kitchenLocation } = kitchenInfo || {};

  const {
    founders = [],
  } = hostDetails || {};

  const aboutText = chefLabel1 ?? '';
  const aboutPreview = aboutText.slice(0, 100);
  const aboutHostTitle = `About ${chefName.split(" ")[0]}`;

  const chefCategories = categories[chefId] || [];

  const chefCuisine = chefList.find((c) => c._id === chefId);
  const cuisineList = chefCuisine?.cuisine?.split(",").map((c) => c.trim()) || [];
  const servingLabel = `Serving ${cuisineList.join(" & ")}`



  
  const experienceImages = useMemo(
    () => getAllPhotos(hostExperience),
    [hostExperience]
  );

  const handleMenuClick = () => {
      dispatch(menuActions.setIsMenuClicked(true));
      dispatch(bottomBarActions.loadTab({ tabName: "menu" }));
      dispatch(chefActions.onMenuClick(chefId));
      // dispatch(bottomBarActions.updateFrom({ from: "dishesScreen" }));
      dispatch(chefActions.onMenuCategorieId(chefId));
      // mixpanel.track("go-to-menu-clicked");
      // clevertap.event.push("go-to-menu-clicked");
    };

  return (
    <div className="hostExpertDetailsContainer">
      <section className="hostExpertSection">
        <h2 className="hostExpertSectionTitle Satoshi">{aboutHostTitle}</h2>
        <div className="hostExpertAboutCard">
          <p className="hostExpertAboutText Satoshi">
            {showFullAboutText ? aboutText : `${aboutPreview} `}
            {!showFullAboutText && (
              <span
                className="hostExpertReadMore"
                onClick={() => setShowFullAboutText(true)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") setShowFullAboutText(true);
                }}
              >
                read more
              </span>
            )}
          </p>
        </div>
      </section>

      <section className="hostExpertSection hostExpertStoriesSection">
        <h2 className="hostExpertSectionTitle Satoshi">
          Stories
        </h2>
        <div className="hostExpertStoriesRow">
          {expertStoryVideos.map((url, index) => (
            <div key={index} className="hostExpertStoryCard">
              {isVideoUrl(url) ? (
                <div key={index} className="hostDineinMediaWrapper">
                  <LazyVideo
                    src={url}
                    className="hostExpertStoryMedia"
                  />
                  <div className="hostExpertStoryPlayIcon">
                    <PlayIconSvg />
                  </div>
                </div>
              ) : (
                <img
                  src={url}
                  alt=""
                  className="hostExpertStoryMedia"
                  loading="lazy"
                />
              )}
              {/* <div className="hostExpertStoryOverlay" /> */}
              {/* <p className="hostExpertStoryText Satoshi">
                <span className="hostExpertStoryTextRegular">
                  Punit acts, you&apos;ll see him as{" "}
                </span>
                <span className="hostExpertStoryTextItalic">Star on Star!</span>
              </p> */}
            </div>
          ))}
        </div>
      </section>

      {!!chefCategories?.length && (
        <section className="hostExpertSection">

          <div className="hostExpertContainer">
            <h2 className="hostExpertSectionTitle Satoshi">{servingLabel}</h2>
            <div onClick={handleMenuClick} className="experiencesViewAllBtn Satoshi">
              View Menu
            </div>
          </div>
          <div className="hostExpertDishesRow">
            {chefCategories.map((category, index) => (
              <div
                key={index}
              className="hostExpertDishItem"
              onClick={() => chefId && onChefClick?.(chefId)}
              role="button"
              tabIndex={0}
            >
              <div className="hostExpertDishImageWrapper">
                <span className="hostExpertDishType">
                  {/* {category.type === "veg" ? <VegIconSvg /> : <NonVegIconSvg />} */}
                </span>
                {category.img ? (
                  <img
                    className="hostExpertDishImage"
                    src={
                      category.img.includes("amazonaws.com")
                        ? category.img
                        : S3_MENU_THUMBNAIL_FOLDER + category.img
                    }
                    alt={category.name}
                  />
                ) : (
                  <div className="hostExpertDishImagePlaceholder" />
                )}
              </div>
              <span className="hostExpertDishName Satoshi">{category.name}</span>
            </div>
          ))}
        </div>
      </section>)}

      {/* <section className="hostExpertSection hostExpertExperienceTypeSection">
        <h2 className="hostExpertSectionTitle Satoshi">Experience type</h2>
        <div className="hostExpertExperienceRow">
          {STATIC_EXPERIENCE_TYPES.map(({ label, icon: Icon }, index) => (
            <div key={index} className="hostExpertExperienceItem">
              <Icon size={20} />
              <span className="hostExpertExperienceText Satoshi">
                {experienceType?.[index] ?? label}
              </span>
            </div>
          ))}
        </div>
      </section> */}

      {showFounders && <FoundersCuratedComponent founders={founders} />}

      {!!experienceImages?.length &&  <div className="experiencesBoxWrapper">
        <div className="experiencesContainer">
          <div className="experiencesLabelTxt Satoshi">Experiences</div>
          <div onClick={onViewAllClick} className="experiencesViewAllBtn Satoshi">
            View all
          </div>
        </div>
        <HostImageGrid experienceImages={experienceImages} onViewAllClick={onViewAllClick} />
      </div>}

      {kitchenLocation?.lat && kitchenLocation?.lng && <section className="hostExpertSection hostExpertLocationSection">
        <h2 className="hostExpertSectionTitle Satoshi">Location</h2>
        <div className="hostExpertLocationCard">
          <div className="hostExpertMapWrapper">
            <iframe
              src={`https://www.google.com/maps?q=${kitchenLocation.lat},${kitchenLocation.lng}&hl=en&z=16&output=embed`}
              className="hostExpertMapImage"
              title="Map"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              style={{ border: 0 }}
            />
          </div>

          <div className="hostExpertLocationText">
            <div className="hostExpertLocationLine Satoshi">
              <span>{distance}</span>
              <span className="hostExpertMetaDot" />
              <span>{locationName}</span>
            </div>
            <div className="hostExpertLocationLine Satoshi">
              {address}
            </div>
          </div>
        </div>
      </section>}
    </div>
  );
};

export default HostDetailsComponent;
